<template>
  <v-responsive class="no-queues" mt-2>
    <v-container>
      <v-row align-content="space-around" justify="space-around">
        <v-col>
          <v-icon x-large color="primary">mdi-reply</v-icon>
          <span class="subheading">{{ $t('queues.jumbotron.watchHint') }}</span>
        </v-col>
      </v-row>
      <v-row align-content="space-around" justify="space-around">
        <v-col>
          <h3 class="display-2 orange--text text--darken-3">
            {{ $t('queues.jumbotron.title') }}
          </h3>
          <span class="title">
            <v-icon color="orange darken-3" large>mdi-alert-circle-outline</v-icon>
            {{ $t('queues.jumbotron.note') }}
          </span>
        </v-col>
      </v-row>
    </v-container>
  </v-responsive>
</template>

<script>
export default {
  name: 'no-queues-notice'
}
</script>

<style scoped>
</style>
